// cn.js
module.exports = {
  router_title_001: "首页",
  router_title_002: "邮件",
  router_title_003: "写信",
  router_title_004: "发送完成",
  router_title_005: "新页读信",
  router_title_006: "超大附件",
  router_title_007: "账号信息",
  router_title_008: "账号安全",
  router_title_009: "异地登录日志",
  router_title_010: "信任登录地点",
  router_title_011: "修改密码",
  router_title_012: "其他邮箱账户（POP）",
  router_title_013: "添加其他邮箱账户",
  router_title_014: "文件夹管理",
  router_title_015: "黑名单",
  router_title_016: "自动转发与回复",
  router_title_017: "自动转发设置日志",
  router_title_018: "邮件分类规则",
  router_title_019: "新建规则",
  router_title_020: "设置日志",
  router_title_021: "常规设置",
  router_title_022: "客户端设置",
  router_title_023: "个性签名",
  router_title_024: "新建签名",
  router_title_025: "反垃圾设置",
  router_title_026: "通讯录",
  router_title_027: "绑定手机",
  router_title_028: "解绑手机",
  wm_lang_9c710b:"文件大小为",
  wm_lang_html_95b351:"编辑",
  wm_lang_html_e0f673:"该功能已被禁用，请联系管理员",
  wm_lang_f90387:"多个关键字之间请以英文逗号分隔",
  wm_lang_html_f3a485:"新建文件夹",
  wm_lang_html_0b543c:"管理员已禁用自动转发到外域",
  wm_lang_html_9c51b4:"续期",
  wm_lang_669656:"规则名字不少于",
  wm_lang_html_e8e492:"增加分类自动转发功能，支持按照过滤条件设置自动转发；",
  wm_lang_fec2b4:"客户端授权码",
  wm_lang_html_24c669:"邮件总数（封）",
  wm_lang_html_3d448d:"三级导航",
  wm_lang_html_0d8f65:"红色简约",
  wm_lang_html_6b0d50:"手机：",
  wm_lang_e680e9:"计算完成",
  wm_lang_58c224:"最多不超过",
  wm_lang_e2ee4e:"每两天",
  wm_lang_53d9ef:"编码选择",
  wm_lang_dbf6d0:"请输入邮箱",
  wm_lang_76ea0d:"密送人",
  wm_lang_html_fb5bf1:"收件人",
  wm_lang_html_eab129:"个人信息",
  wm_lang_b09b04:"电话最多添加",
  wm_lang_html_4de530:"语言及时区",
  wm_lang_cc97eb:"目的文件夹隶属于源文件夹",
  wm_lang_html_7a3680:"邮件开发部",
  wm_lang_5d44d9:"存在同名文件夹",
  wm_lang_e747e8:"秒再次获取",
  wm_lang_b720a6:"审核中",
  wm_lang_953b40:"不包含附件",
  wm_lang_html_9439fa:"开启客户端授权码后，原邮箱密码将不能登录客户端，只能使用新增的授权码登录。",
  wm_lang_html_2df6a3:"发件人：",
  wm_lang_2f234b:"草稿保存成功",
  wm_lang_html_38cf16:"确定",
  wm_lang_425169:"邮件内容",
  wm_lang_html_d43e13:"组织通讯录",
  wm_lang_html_043897:"邮件短信提醒",
  wm_lang_199536:"邮箱密码不能为空",
  wm_lang_ef0b42:"模块扩容",
  wm_lang_html_d3298c:"个人通讯录",
  wm_lang_html_f10ed4:"新建规则",
  wm_lang_html_a34e49:"此文件夹下没有任何邮件。",
  wm_lang_html_5ee6c3:"拖拽添加",
  wm_lang_html_55405e:"导出",
  wm_lang_c566ca:"服务器",
  wm_lang_html_5abe91:"未星标",
  wm_lang_d87502:"个字符以上主持人邮箱填写",
  wm_lang_b7612b:"空",
  wm_lang_html_fd5757:"增加钓鱼链接提醒，当点击邮件正文链接时弹出安全提示；",
  wm_lang_19cd24:"云视",
  wm_lang_0c686f:"输入长度不超过",
  wm_lang_html_973732:"已转发",
  wm_lang_331b7f:"不包括",
  wm_lang_ff1c7d:"查看信头",
  wm_lang_6a3db1:"封邮件",
  wm_lang_c9a507:"更新提示",
  wm_lang_58f966:"大小",
  wm_lang_html_5b0520:"应用",
  wm_lang_1e6021:"新页签打开",
  wm_lang_4848e1:"垃圾邮件提醒设置",
  wm_lang_7a615e:"员工编号",
  wm_lang_e8ed1b:"编辑其他邮箱账号",
  wm_lang_b33403:"每次只能导入",
  wm_lang_8c3f97:"下午好！",
  wm_lang_html_1dea3a:"且",
  wm_lang_379b24:"不超过",
  wm_lang_9aab18:"编辑组",
  wm_lang_html_e5f71f:"搜索",
  wm_lang_abeee9:"反垃圾级别",
  wm_lang_f12e4a:"如果",
  wm_lang_html_da671a:"微信：",
  wm_lang_html_cb0ed5:"紧急",
  wm_lang_188e4b:"移动到指定文件夹",
  wm_lang_320dcb:"密码强度",
  wm_lang_html_88f1fc:"此发件人",
  wm_lang_d716f1:"到",
  wm_lang_html_5b6010:"和一些其他应用程序的",
  wm_lang_93d159:"已发送",
  wm_lang_html_f1d5f5:"列表布局",
  wm_lang_a11cc7:"请输入内容",
  wm_lang_html_5120e6:"有超过",
  wm_lang_html_c247ad:"未读邮件",
  wm_lang_00237d:"密送人：",
  wm_lang_20a495:"复制成功",
  wm_lang_html_a7a6eb:"的邮件",
  wm_lang_d1a00e:"附件名称",
  wm_lang_html_58037b:"：",
  wm_lang_c14d45:"设置页面包屑导航",
  wm_lang_html_4d7ea6:"保存草稿",
  wm_lang_8ea35c:"修改签名",
  wm_lang_2299ac:"请输入正确的传真",
  wm_lang_cae255:"上传时间",
  wm_lang_84bef0:"修改规则",
  wm_lang_517f89:"传真重复",
  wm_lang_html_189c20:"未选中任何联系人，单击一条联系人信息在此",
  wm_lang_html_7cf1f5:"每页显示",
  wm_lang_html_ee8ecb:"优先级",
  wm_lang_e366cc:"设置",
  wm_lang_html_c3ba16:"已归档",
  wm_lang_465afe:"人",
  wm_lang_html_0ec9ea:"更多",
  wm_lang_29d09a:"上海市普陀区金沙江路",
  wm_lang_2c825a:"选择时间",
  wm_lang_html_5ef69f:"图标",
  wm_lang_1ca99a:"产品公告",
  wm_lang_html_8becc4:"反垃圾设置",
  wm_lang_abb501:"金色时光",
  wm_lang_html_a71852:"或",
  wm_lang_html_a2247c:"打包下载",
  wm_lang_a2b5f6:"操作者邮箱",
  wm_lang_8b6aed:"在线预览",
  wm_lang_4c50ee:"头像",
  wm_lang_a53c6f:"您要删除掉这条规则吗？",
  wm_lang_html_0dee1e:"审核结果：",
  wm_lang_html_d9cc43:"超大附件空间信息",
  wm_lang_96d2b7:"永久删除",
  wm_lang_html_cecc29:"写信",
  wm_lang_f4578a:"密码修改成功，请重新登录。",
  wm_lang_dc9dae:"非法地址或域，请重新输入！",
  wm_lang_829abe:"分组",
  wm_lang_2b45e2:"是否继续",
  wm_lang_6f4450:"每日分享",
  wm_lang_873178:"点击关闭标签",
  wm_lang_e5a33f:"邮件最大值最小值填写不正确（最小值要小于等于最大值）",
  wm_lang_78f395:"下拉",
  wm_lang_html_411fee:"网页制作工程师",
  wm_lang_1ec4aa:"小于等于",
  wm_lang_html_db1c89:"首页",
  wm_lang_2e28bb:"收信时姓名显示",
  wm_lang_html_ba7cb4:"代办邮件",
  wm_lang_a820f8:"已设为已读",
  wm_lang_e39ffe:"请输入密码",
  wm_lang_html_1d4403:"超大附件自上传之日起自动保存",
  wm_lang_html_1535fc:"发送",
  wm_lang_df23a5:"主题：",
  wm_lang_html_a06d40:"开通",
  wm_lang_930882:"个",
  wm_lang_html_db06c7:"测试",
  wm_lang_html_b2352a:"保存到已发送",
  wm_lang_2ad202:"仅对通讯录中的联系人发送自动回复",
  wm_lang_html_3be934:"已读邮件",
  wm_lang_fe30da:"转发地址已经存在！",
  wm_lang_html_ff05d1:"邮件从小到大",
  wm_lang_html_e77c07:"账号安全等级：",
  wm_lang_html_1b1d05:"发送至",
  wm_lang_3a580c:"回复全部",
  wm_lang_html_055692:"添加联系人",
  wm_lang_1e1459:"部门",
  wm_lang_3c3479:"选项一",
  wm_lang_html_ec8d26:"邮箱容量",
  wm_lang_14b860:"至少选择一项执行动作",
  wm_lang_html_21e106:"转发",
  wm_lang_html_543b04:"已选中",
  wm_lang_html_7fc88a:"修改密码",
  wm_lang_html_a86903:"更多信息",
  wm_lang_b0b69e:"请输入正确的传真号码",
  wm_lang_html_fcec0a:"公司网址：",
  wm_lang_9970ad:"主题",
  wm_lang_html_2f78b7:"作为附件转发",
  wm_lang_1bb474:"新密码不能与原密码相同",
  wm_lang_fd2bf0:"仅在以下时间段生效",
  wm_lang_3d3057:"自动收信",
  wm_lang_9bd442:"云课堂",
  wm_lang_d1d904:"执行动作",
  wm_lang_cf10dc:"位",
  wm_lang_63e0ca:"需要回执",
  wm_lang_23b8db:"当邮件到达时",
  wm_lang_a67a18:"个邮件签名",
  wm_lang_60d045:"姓名",
  wm_lang_cb0804:"默认密送地址",
  wm_lang_0d5523:"每六天",
  wm_lang_html_c39922:"退出",
  wm_lang_html_3b47d7:"文件，且不超过",
  wm_lang_5ea696:"回复时加入原信",
  wm_lang_1501d5:"邮件主题",
  wm_lang_6ed179:"规则名字不能为空",
  wm_lang_html_11ccee:"等",
  wm_lang_html_47595b:"版",
  wm_lang_fb5158:"请输入正确的合法邮箱",
  wm_lang_72d55e:"输入新密码",
  wm_lang_html_fa8b0f:"审核时限：",
  wm_lang_html_ac1e1c:"收件人：",
  wm_lang_19eb5b:"原始文件字段名称",
  wm_lang_43ef05:"介于",
  wm_lang_html_5aefca:"布局",
  wm_lang_31fd4b:"垃圾邮件删除时间",
  wm_lang_b15d91:"关闭",
  wm_lang_710ad0:"禁用",
  wm_lang_80c18f:"搜索电子邮件",
  wm_lang_812d1b:"保存客户端发信",
  wm_lang_cb6d41:"您不会收到来自黑名单地址的邮件。",
  wm_lang_9c19a4:"请输入原密码",
  wm_lang_html_413db9:"条匹配，请输入更多信息以缩小范围",
  wm_lang_html_bbdfe1:"陈旭",
  wm_lang_html_ecac25:"主题降序",
  wm_lang_622b43:"家庭",
  wm_lang_c33c30:"商务办公",
  wm_lang_ad9c40:"请填写内容",
  wm_lang_092ba7:"高级搜索",
  wm_lang_html_eb3c99:"京",
  wm_lang_a0db8e:"“邮件”、“电话”、“传真”之外的其他字段只能有唯一对应",
  wm_lang_html_5d36f1:"工作信息",
  wm_lang_html_01cd93:"删除已自动转发的邮件",
  wm_lang_3a17b7:"分钟",
  wm_lang_fd2515:"自动回复勾选后回复内容不能为空",
  wm_lang_d47c7f:"弄",
  wm_lang_183abe:"通讯录",
  wm_lang_80ef9d:"上传头像图片大小不能超过",
  wm_lang_html_6785d8:"完成代办",
  wm_lang_html_8d9a07:"导入",
  wm_lang_f41cf0:"请输入正确邮箱或域名",
  wm_lang_3b1083:"保存成功",
  wm_lang_html_6afaf4:"执行以下动作",
  wm_lang_4ebcc8:"域公告邮件",
  wm_lang_9fd1b7:"单选",
  wm_lang_c054fb:"更新记录",
  wm_lang_cd649f:"时间范围",
  wm_lang_ca2153:"勾选了自动转发，则自动转发内容不能为空",
  wm_lang_3b239d:"无主题",
  wm_lang_4249f2:"选项三",
  wm_lang_f13597:"选择对应字段名称",
  wm_lang_d3637f:"发信",
  wm_lang_html_c57120:"题",
  wm_lang_html_bb4546:"立即优化",
  wm_lang_87ba17:"小时到期",
  wm_lang_html_b8ef0f:"已勾选",
  wm_lang_html_46042d:"超大附件",
  wm_lang_html_5f10ee:"经典木纹",
  wm_lang_html_0807a3:"青青幽境",
  wm_lang_3cebfa:"上午好！",
  wm_lang_html_2d66a1:"只能上传",
  wm_lang_html_456b82:"生日：",
  wm_lang_69be67:"修改成功",
  wm_lang_bff744:"举报",
  wm_lang_062ebd:"读信详情页",
  wm_lang_c9ef57:"如果您休假时无法回复邮件，可以设置自动回复告知对方。",
  wm_lang_html_df23a5:"主题：",
  wm_lang_b2f801:"您确定要关闭",
  wm_lang_1efeae:"缓慢",
  wm_lang_html_812024:"审核邮件",
  wm_lang_1b3bf0:"写信默认字体",
  wm_lang_922a77:"自动回复",
  wm_lang_7a311d:"回复：【升级公告】畅听支持",
  wm_lang_html_bffb1c:"个性签名",
  wm_lang_185839:"窗口布局",
  wm_lang_9b3884:"请填写最大值",
  wm_lang_html_773926:"不少于",
  wm_lang_html_939d53:"提交",
  wm_lang_html_96d2b7:"永久删除",
  wm_lang_html_de8610:"二级标题",
  wm_lang_html_8c18cb:"此邮件已被审核完成：由于此邮件在审核时限内，审核人并没有做出裁决，此邮件已被正常投递",
  wm_lang_html_ef801d:"收信",
  wm_lang_66c3e5:"绿意风情",
  comm_lang_0001:"天的邮件",
  wm_lang_html_738bc9:"您确定要删除所选的联系人？",
  wm_lang_html_607e7a:"查看",
  wm_lang_7d41a2:"总分块：",
  wm_lang_2005d7:"为了您的账号安全，请修改密码",
  wm_lang_html_615db5:"张三",
  wm_lang_faaadc:"序号",
  wm_lang_318305:"新写信页打开，您之前所编辑的内容已存为草稿",
  wm_lang_html_3be506:"收取设置",
  wm_lang_html_38294f:"显示及换肤",
  wm_lang_html_76b8e6:"传真：",
  comm_lang_0006:"查找到",
  comm_lang_0007:"发件人包含",
  comm_lang_0008:"收件人包含",
  comm_lang_0009:"主题包含",
  comm_lang_0002:"共",
  comm_lang_0003:"封",
  comm_lang_0004:"邮件",
  comm_lang_0005:"搜索结果",
  wm_lang_9f22bc:"选字体",
  wm_lang_html_c7bc5c:"添加密送",
  comm_lang_0010:"附件名包含",
  wm_lang_d32b45:"请填写签名内容",
  wm_lang_html_2f4aad:"删除",
  comm_lang_0011:"时间从",
  wm_lang_9e4d59:"邮箱密码",
  comm_lang_0012:"到",
  wm_lang_html_8e16eb:"邮件分类规则",
  wm_lang_html_afcb3b:"家庭地址：",
  wm_lang_cb0ed5:"紧急",
  wm_lang_html_2d7a2f:"确",
  wm_lang_15d410:"个字符",
  wm_lang_html_c45357:"系统提示",
  wm_lang_457406:"取消上传",
  wm_lang_2de0d4:"小时",
  wm_lang_5e579b:"请输入正确数值",
  wm_lang_html_882106:"分类规则设置日志",
  wm_lang_92448a:"手机号码",
  wm_lang_html_9989a0:"标记为",
  wm_lang_html_e41447:"打印",
  wm_lang_html_9ef98a:"对不起，该文件暂不支持预览",
  comm_lang_0017:"没有已星标的邮件，您可以为重要邮件加注星标，使邮件查找更为方便。",
  comm_lang_0018:"没有找到",
  comm_lang_0019:"的邮件",
  wm_lang_625fb2:"取消",
  comm_lang_0013:"的",
  comm_lang_0014:"页",
  wm_lang_be6f79:"默认签名",
  comm_lang_0015:"没有任何邮件",
  comm_lang_0016:"此文件夹下没有任何邮件。",
  comm_lang_0020:"没有任何邮件符合您的搜索条件，请您重新设定搜索规则。",
  wm_lang_06e84a:"继续上传",
  wm_lang_2b6bc0:"操作",
  comm_lang_0021:"其中",
  comm_lang_0022:"未读邮件",
  comm_lang_0023:"全部置为已读",
  wm_lang_22b433:"草稿",
  wm_lang_html_f26ef9:"下载",
  wm_lang_ea8b1d:"无法创建",
  wm_lang_6fc450:"不显示垃圾邮件中的图片，手动点击后显示",
  wm_lang_c4c3f3:"原邮箱中保留副本",
  wm_lang_d7ec2d:"名称",
  wm_lang_html_b15d91:"关闭",
  wm_lang_d28df0:"姓名、拼音、首字母搜索联系人",
  wm_lang_7f72e8:"在线客服",
  wm_lang_35242c:"普通",
  comm_lang_0028:"1.仅支持撤回发往本邮件系统内的邮件，不支持撤回发往其它邮件系统的邮件",
  wm_lang_1f4c10:"文件夹",
  comm_lang_0029:"2.仅支持撤回网页邮箱中的邮件，不支持撤回被邮件客户端收取到本地的邮件",
  wm_lang_3ffa1d:"包括",
  comm_lang_0024:"立即删除所有垃圾邮件",
  comm_lang_0025:"邮件加密",
  wm_lang_e9e805:"邮件",
  comm_lang_0026:"撤回邮件",
  wm_lang_html_f952f5:"同步至云日程",
  comm_lang_0027:"您确定要撤回邮件吗？如果撤回成功，对方将只能看到邮件的主题，并得到已被撤回的提示。",
  comm_lang_0031:"4.只能撤回7日内发送的邮件",
  wm_lang_html_7d0177:"提示：当对方发来的邮件标题包含",
  comm_lang_0032:"撤回失败，邮件超过7天或已被收件人删除",
  comm_lang_0033:"正在撤回",
  wm_lang_bc4364:"无限制",
  comm_lang_0034:"完成撤回",
  comm_lang_0030:"3.撤回结果将通过系统邮件通知您",
  wm_lang_9c3c31:"要添加到的组不能为空",
  wm_lang_3b3190:"附加意见",
  wm_lang_60eec8:"运维",
  wm_lang_b652de:"职位",
  wm_lang_e11f7c:"左边的值要小于右边",
  comm_lang_0039:"邮件撤回失败",
  wm_lang_2432b5:"备注",
  wm_lang_b58c75:"添加",
  comm_lang_0035:"撤回失败",
  comm_lang_0036:"成功撤回",
  comm_lang_0037:"对方非本邮件系统邮箱，无法撤回",
  comm_lang_0038:"撤回失败，邮件可能已被删除",
  wm_lang_86ed3d:"移动到",
  comm_lang_0042:"部分撤回",
  comm_lang_0043:"发信方已撤回邮件",
  wm_lang_d6cc4b:"第四步，开始上传",
  comm_lang_0044:"此邮件已被发件人撤回",
  comm_lang_0045:"发信时间",
  wm_lang_html_ac8ccc:"左右布局",
  wm_lang_html_74c0d8:"提醒语言",
  wm_lang_html_0611d8:"）",
  wm_lang_2456c8:"请完善信息",
  comm_lang_0040:"撤回状态",
  wm_lang_7a2e8b:"这不是垃圾邮件",
  comm_lang_0041:"已全部撤回",
  wm_lang_cef67a:"日文",
  wm_lang_html_317a66:"中包含",
  wm_lang_a81052:"密码",
  wm_lang_33130f:"操作成功",
  wm_lang_8347a9:"修改",
  wm_lang_html_6bac4d:"导入联系人",
  wm_lang_437839:"邮件主题长度限制为",
  wm_lang_html_be5fbb:"保存",
  wm_lang_43b510:"剩余",
  wm_lang_4076f9:"写信页",
  wm_lang_html_fb8f3d:"请选择新文件存放的位置：",
  wm_lang_cda4d5:"从联系人中选择",
  wm_lang_38e3ff:"收到的共享",
  wm_lang_f15261:"片段",
  wm_lang_e13556:"包含",
  wm_lang_69e308:"含附件",
  wm_lang_732796:"彻底删除",
  wm_lang_html_ba8713:"信任",
  wm_lang_ec84ea:"公司网址",
  comm_lang_0046:"年",
  wm_lang_8e97c5:"发信时间",
  comm_lang_0047:"月",
  wm_lang_aef8cb:"中文繁体",
  comm_lang_0048:"日",
  wm_lang_f35fae:"传真最多添加",
  comm_lang_0049:"时",
  comm_lang_0053:"设置密码",
  wm_lang_78b124:"编辑其他邮箱账户",
  wm_lang_d17143:"转发信头",
  wm_lang_html_2a214e:"带附件回复全部",
  comm_lang_0054:"确认密码",
  comm_lang_0055:"查看密码",
  comm_lang_0056:"隐藏密码",
  comm_lang_0050:"分",
  comm_lang_0051:"设置的时间已过期",
  wm_lang_41e17a:"调整通报",
  comm_lang_0052:"邮件加密后，收件人需要解密才能查看邮件内容",
  wm_lang_html_2f8d6f:"昨天",
  wm_lang_html_a552fc:"邮箱用户登录",
  wm_lang_html_2ef722:"拒收",
  wm_lang_html_3c8045:"等客户端发信后保存到服务器，请选择此项。（",
  wm_lang_html_4bea88:"已回复",
  wm_lang_html_31c7ca:"自动加入通讯录",
  wm_lang_0c0335:"待办时间",
  wm_lang_de0f82:"保存副本在邮箱中",
  wm_lang_01d7aa:"的",
  wm_lang_html_230505:"撤回",
  wm_lang_58ccec:"移动中",
  wm_lang_html_49f15f:"嵌套列表：",
  wm_lang_html_e4a827:"星标邮件",
  wm_lang_38cf16:"确定",
  wm_lang_html_ca7b67:"再次编辑",
  comm_lang_0057:"取消密码",
  comm_lang_0058:"您好：",
  wm_lang_60ae02:"包含附件",
  comm_lang_0059:"这是一封加密邮件，需要解密后才能查看邮件内容，您可以通过其它方式向发件人询问密码。",
  wm_lang_6fc9ce:"自动转发邮箱填写有误",
  comm_lang_0064:"您可以手动添加常用登录地址至",
  comm_lang_0065:"信任登录地点",
  comm_lang_0066:"，邮箱账号异地登录时系统自动发送异地登录提醒，查看",
  comm_lang_0067:"信任登录地点",
  comm_lang_0060:"请输入密码",
  comm_lang_0061:"邮件解密失败，请重新输入密码",
  comm_lang_0062:"邮件已解密，以下是解密后的邮件内容：",
  comm_lang_0063:"异地登录提醒",
  wm_lang_html_866bc3:"步骤一：选择要上传的",
  wm_lang_71b068:"宋体",
  wm_lang_html_c360e9:"排序",
  wm_lang_5719f5:"回执取消",
  wm_lang_a652de:"输入的字符串过长",
  wm_lang_39c764:"端口号",
  wm_lang_f013ea:"加载中",
  wm_lang_html_4404d5:"账号安全",
  wm_lang_ee3f55:"国家",
  comm_lang_0068:"因IP定位精度有限，国内地点仅精确到\"市\"",
  wm_lang_f8de3d:"删除中",
  comm_lang_0069:"请选择国家",
  wm_lang_a9e825:"邮件图片显示设置",
  wm_lang_d3298c:"个人通讯录",
  comm_lang_0075:"操作",
  comm_lang_0076:"智能添加",
  comm_lang_0077:"手动添加",
  wm_lang_html_961cac:"代发",
  comm_lang_0078:"地点已存在",
  comm_lang_0071:"请选择市",
  wm_lang_html_52228f:"扩容",
  wm_lang_html_1efeae:"缓慢",
  comm_lang_0072:"本次登录地点：",
  wm_lang_7e951d:"操作时间",
  comm_lang_0073:"当前信任地点",
  comm_lang_0074:"类型",
  wm_lang_44a0b8:"选字号",
  wm_lang_a7d3be:"底栏容器",
  wm_lang_aa8b9d:"家庭地址",
  wm_lang_2f4aad:"删除",
  comm_lang_0070:"请选择省",
  wm_lang_3bb47b:"编辑成功",
  wm_lang_b1baab:"不显示所有邮件中的图片，手动点击后显示",
  wm_lang_html_7eacb4:"真实姓名",
  wm_lang_0f43f5:"密码不能小于",
  wm_lang_d43e13:"组织通讯录",
  wm_lang_html_a42d13:"张三邮件名称",
  wm_lang_html_694fc5:"刷新",
  wm_lang_0875ef:"￥",
  wm_lang_f7c30e:"添加超大附件",
  comm_lang_0079:"异地登录日志",
  wm_lang_32c65d:"标题",
  wm_lang_719156:"原发信时间：",
  wm_lang_html_0a25da:"支持导入",
  comm_lang_0086:"操作者",
  wm_lang_47631c:"请输入文本名称",
  comm_lang_0087:"操作时间",
  comm_lang_0088:"操作IP",
  wm_lang_91e9e8:"定时审核",
  comm_lang_0089:"操作内容",
  wm_lang_28cf54:"默认抄送地址",
  comm_lang_0082:"登录IP",
  comm_lang_0083:"参考地点",
  wm_lang_439d6f:"您的邮箱密码已过期，为了您的账号安全，请修改密码",
  comm_lang_0084:"登录方式",
  comm_lang_0085:"设置日志",
  wm_lang_ce917f:"自定义名称不能为空",
  comm_lang_0080:"最近30天内的异地登录日志",
  comm_lang_0081:"登录时间",
  wm_lang_981cbe:"至",
  wm_lang_html_400521:"保留已自动转发的邮件",
  wm_lang_a5bfd7:"新增成功",
  wm_lang_html_deb009:"下载安装",
  wm_lang_1d468b:"结束日期",
  wm_lang_7a427c:"质量管理部",
  wm_lang_html_22b433:"草稿",
  wm_lang_9989a0:"标记为",
  wm_lang_1c8ac2:"客户端授权码”功能么？开启成功后，原邮箱密码将不能登录客户端，只能使用新增的授权码登录。",
  wm_lang_html_8b6aed:"在线预览",
  wm_lang_html_457406:"取消上传",
  wm_lang_bffb1c:"个性签名",
  wm_lang_02aaf1:"楷体",
  comm_lang_0097:"保存副本在邮箱中",
  wm_lang_2e42cc:"剩余保留期限",
  comm_lang_0098:"您可以关闭撤回页面，我们会将结果发送至您的邮箱",
  wm_lang_html_b50566:"、",
  comm_lang_0099:"安全设置",
  comm_lang_0093:"执行动作",
  comm_lang_0094:"自动转发设置日志",
  comm_lang_0095:"转发地址",
  wm_lang_238ae0:"剩余时间：",
  comm_lang_0096:"操作者邮箱",
  comm_lang_0090:"规则名称",
  comm_lang_0091:"规则状态",
  wm_lang_8b9c9b:"读取文件失败",
  comm_lang_0092:"触发条件",
  wm_lang_30f7dd:"连接",
  wm_lang_html_922a77:"自动回复",
  wm_lang_e3d664:"请输入正确的分机号码",
  wm_lang_46323b:"是否回执邮件？",
  wm_lang_dac715:"超大附件上传成功",
  wm_lang_html_f12e4a:"如果",
  wm_lang_html_bbdb15:"添加至邮件",
  wm_lang_0807a3:"青青幽境",
  wm_lang_html_bdc07d:"协议建议关闭此项）",
  wm_lang_fbd05a:"请选择时间",
  wm_lang_html_e0a113:"回",
  wm_lang_be5fbb:"保存",
  wm_lang_8e16eb:"邮件分类规则",
  wm_lang_0f9b40:"分片",
  wm_lang_html_126fc3:"如果希望使用",
  wm_lang_cdd051:"请正确填写最大值",
  wm_lang_193a8c:"电话号码",
  wm_lang_html_9e5ffa:"基本信息",
  wm_lang_5cc232:"已删除",
  wm_lang_0611d8:"）",
  wm_lang_html_06ee96:"修改设置",
  wm_lang_6a5aa0:"已成功将联系人进行分组",
  wm_lang_62a7e4:"新密码不符合规则",
  wm_lang_html_f54c5e:"在本次网络安全攻防演练中，",
  wm_lang_html_b58c75:"添加",
  wm_lang_2ef722:"拒收",
  wm_lang_html_e4ef4a:"管理文件夹",
  wm_lang_827d98:"存放至",
  wm_lang_ea57da:"右侧页签",
  wm_lang_html_6297bc:"不选",
  wm_lang_6231a2:"未回复",
  wm_lang_98c30b:"第二步，获取",
  wm_lang_6d37b4:"搜索结果（个人通讯录）",
  wm_lang_f26ef9:"下载",
  wm_lang_702513:"发送中",
  wm_lang_html_374237:"（",
  wm_lang_html_d3b98f:"，",
  wm_lang_html_3593a5:"部门：",
  wm_lang_549308:"夜深了，早休息！",
  wm_lang_html_713272:"普通附件",
  wm_lang_da0291:"不包含",
  wm_lang_708c9d:"请选择",
  wm_lang_html_a6c60b:"格式有误，示例",
  wm_lang_8441b3:"不限",
  wm_lang_73347e:"第一步，计算完成，并对",
  wm_lang_d41a62:"延期成功",
  wm_lang_html_00237d:"密送人：",
  wm_lang_7c6a2c:"姓名、邮箱、手机号搜索联系人",
  wm_lang_html_4cbc13:"文件夹：",
  wm_lang_html_98f89e:"该操作将把联系人在所有组中删除。",
  wm_lang_b1c5ea:"是否要将此邮件保存至草稿",
  wm_lang_html_b59b00:"已使用",
  wm_lang_html_528e20:"：选择规则的触发条件",
  wm_lang_html_7bbc73:"主题",
  wm_lang_e5b49e:"真实",
  wm_lang_html_e39b19:"时间从新到旧",
  wm_lang_html_14e6d8:"时间：",
  wm_lang_7b6234:"请填写正确的邮箱地址",
  wm_lang_41716f:"公司",
  wm_lang_html_ae4fd4:"立即删除所有垃圾邮件",
  wm_lang_2c35d9:"黑名单地址",
  wm_lang_6eb535:"公司动态",
  wm_lang_html_e9e805:"邮件",
  wm_lang_694fc5:"刷新",
  wm_lang_html_7fe4a6:"其他邮箱账号",
  wm_lang_9088d8:"按附件转发最多支持勾选",
  wm_lang_html_35242c:"普通",
  wm_lang_html_92e3a8:"帮助",
  wm_lang_html_da4495:"邮箱：",
  wm_lang_html_c82a9d:"收取",
  wm_lang_html_21efd8:"暂无数据",
  wm_lang_html_cb8dc2:"主题升序",
  wm_lang_5c7c95:"删除账号失败",
  wm_lang_html_69e308:"含附件",
  wm_lang_69e94f:"点击此处可快捷回复给所有人",
  wm_lang_html_857cee:"则",
  wm_lang_a7699b:"上传成功",
  wm_lang_b44c0f:"开始日期",
  wm_lang_html_183abe:"通讯录",
  wm_lang_html_3a580c:"回复全部",
  wm_lang_e4a827:"星标邮件",
  wm_lang_ca7b67:"再次编辑",
  wm_lang_d0f6ef:"计算的当前分块：",
  wm_lang_html_2c808b:"点击上传",
  wm_lang_042be4:"仅从本组移除",
  wm_lang_html_980b27:"封",
  wm_lang_html_a00f23:"封邮件已选中",
  wm_lang_a98473:"文件夹名称",
  wm_lang_html_8f4f08:"通讯录中备注姓名",
  wm_lang_html_2064fc:"不显示",
  wm_lang_html_b79a4e:"返",
  wm_lang_4bea88:"已回复",
  wm_lang_html_63e0ca:"需要回执",
  wm_lang_14fe7d:"我的名称",
  wm_lang_50a9be:"公司邮编",
  wm_lang_html_f1d4ff:"自定义",
  wm_lang_html_cf10dc:"位",
  wm_lang_66f0da:"附件上传尚未完成，请稍候",
  wm_lang_3fdaea:"添加成功",
  wm_lang_098730:"且不能包含",
  wm_lang_a46aa1:"添加其他邮箱账号",
  wm_lang_html_6ffab1:"其它选项",
  wm_lang_html_40ad89:"公司邮编：",
  wm_lang_f23656:"最多创建",
  wm_lang_0007d1:"删除成功",
  wm_lang_bce314:"放入垃圾邮件文件夹（推荐）",
  wm_lang_198d41:"不能添加自己的邮箱",
  wm_lang_html_0f87e0:"更新提示信息",
  wm_lang_4f21b0:"传真",
  wm_lang_html_3149de:"取消勾选",
  wm_lang_html_53cab4:"账号信息",
  wm_lang_d0a548:"满足以上条件时：则",
  wm_lang_eb0ef8:"电话最大数量为",
  wm_lang_0182f1:"时尚酷黑",
  wm_lang_b2352a:"保存到已发送",
  wm_lang_2cff3b:"仿宋",
  wm_lang_5a93d3:"电话",
  wm_lang_d7c0a1:"企业邮箱",
  wm_lang_168dfa:"隶书",
  wm_lang_7f9402:"收信人：",
  wm_lang_html_bee912:"查询",
  wm_lang_6a23f1:"搜索结果（组织结构）",
  wm_lang_html_ae2e1f:"管理员已禁用自动转发",
  wm_lang_html_f03d42:"包含成员：",
  wm_lang_html_d16180:"昵称：",
  wm_lang_dec892:"：",
  wm_lang_html_2bf9a9:"群发单显",
  wm_lang_db1c89:"首页",
  wm_lang_d6aac9:"无法移动",
  wm_lang_e06494:"公司地址",
  wm_lang_18c634:"默认",
  wm_lang_19ac67:"低",
  wm_lang_html_7a2e8b:"这不是垃圾邮件",
  wm_lang_01468d:"端口号不能为空",
  wm_lang_html_1edff0:"回复",
  wm_lang_html_dfe170:"无限期",
  wm_lang_html_f25118:"您的邮件已发送！",
  wm_lang_21e106:"转发",
  wm_lang_html_ecda36:"对不起，文件过大，建议您下载之后进行查看",
  wm_lang_b5771a:"登录后默认显示",
  wm_lang_561caa:"邮箱格式错误",
  wm_lang_5ce1e1:"邮件另存下载",
  wm_lang_461d8d:"最新公告",
  wm_lang_3bc5e6:"邮箱",
  wm_lang_54e5de:"上传失败",
  wm_lang_ce219a:"最先做出裁决的审核人的结果，即作为最终裁决结果",
  wm_lang_9365f3:"邮件主题标题邮件主题标题邮件主题标题邮件主题标题",
  wm_lang_html_27dfde:"员工编号：",
//自定义多语言字段://自定义多语言字段
  wm_lang_3755ef:"正在验证账号",
  wm_lang_html_1501d5:"邮件主题",
  wm_lang_8572ea:"请填写最小值",
  wm_lang_html_f6d477:"公司：",
  wm_lang_html_092ba7:"高级搜索",
  wm_lang_html_2dc4ac:"北京二六三企业通信有限公司",
  wm_lang_738e4a:"您查看的公告已经不存在",
  wm_lang_314f60:"保存成功，需要",
  wm_lang_7093b9:"已取消清空",
  wm_lang_cd0ed2:"已移动到收件箱",
  wm_lang_f7a9dd:"此邮件内容已被修改",
  wm_lang_html_7a311d:"回复：【升级公告】畅听支持",
  wm_lang_67bc37:"网盘",
  wm_lang_641b90:"自动转发勾选后转发内容不能为空",
  wm_lang_7650a1:"不支持空格",
  wm_lang_c34281:"已取消删除",
  wm_lang_20601f:"电话重复",
  wm_lang_002a67:"最近使用日期",
  wm_lang_a12b8a:"我的文件",
  wm_lang_html_26f9bf:"子菜单",
  wm_lang_cfbf6f:"微信",
  wm_lang_html_d7405e:"列表名称：",
  wm_lang_b43f83:"节点点击回调",
  wm_lang_61f562:"此操作将永久删除该文件",
  wm_lang_html_7b4a28:"邮箱服务",
  wm_lang_html_aa4d94:"消",
  wm_lang_3c18db:"账号检测图标",
  wm_lang_e2cd2e:"客户端授权码”功能么？关闭成功后，所有客户端授权码将会被全部删除，只能使用原邮箱密码登录客户端。",
  wm_lang_html_383698:"最近登录日志：",
  wm_lang_html_35c8ad:"自动转发",
  wm_lang_371528:"市",
  wm_lang_8d90d2:"选择超大附件",
  wm_lang_html_5cc232:"已删除",
  wm_lang_html_3b3495:"修复写信页面对收件人地址合法性的校验问题；",
  wm_lang_47b0da:"需所有审核人审核通过，邮件才会被正常投递；若其中一人做出拒绝判定，此邮件则被删除",
  wm_lang_html_66c3e5:"绿意风情",
  wm_lang_html_c6b4d7:"电话：",
  wm_lang_0c1fec:"秒",
  wm_lang_18d771:"请输入正确的手机号码",
  wm_lang_243e1d:"授权码用途不能为空",
  wm_lang_9034c8:"预览签名",
  wm_lang_ba6025:"多个邮箱地址之间请以英文逗号分隔",
  wm_lang_a1d1e5:"大于等于",
  wm_lang_html_c228dd:"封邮件，",
  wm_lang_html_cdd451:"已全部撤回",
  wm_lang_23eb0e:"昵称",
  wm_lang_196ef3:"家庭邮编",
  wm_lang_html_0eab0c:"代发邮件：请注意！",
  wm_lang_612c43:"添加其他邮箱账户",
  wm_lang_html_b3b1f7:"剔除",
  wm_lang_html_508db5:"登录时收取",
  wm_lang_html_465afe:"人",
  wm_lang_html_61a68d:"无附件",
  wm_lang_dade72:"设置页表单组件",
  wm_lang_html_6a3db1:"封邮件",
  wm_lang_html_74e5c0:"定时发送",
  wm_lang_9ef16d:"工具栏按钮显示",
  wm_lang_671c0d:"日语",
  wm_lang_5c6881:"未填写",
  wm_lang_html_7854b5:"启用",
  wm_lang_html_918b52:"未选中任何联系人，单击一条联系人信息在此处显示",
  wm_lang_html_69a924:"安全策略零失误",
  wm_lang_html_f6ccd0:"邮件大小",
  wm_lang_bc2f65:"韩文",
  wm_lang_870802:"规则名称",
  wm_lang_html_0be5a1:"换肤",
  wm_lang_1e86ec:"删除账号成功",
  wm_lang_e3127c:"格式",
  wm_lang_5893fa:"邮箱账号",
  wm_lang_c2460e:"传真最大数量为",
  wm_lang_5ee1ff:"邮箱名不能为空",
  wm_lang_html_a8b0c2:"全部",
  wm_lang_12da81:"写信完成页",
  wm_lang_html_cbfcf6:"设置个性签名",
  wm_lang_20be4e:"加载中，请稍后",
  wm_lang_8483ed:"生日",
  wm_lang_e6f070:"审核时间",
  wm_lang_html_645dbc:"预览",
  wm_lang_html_625fb2:"取消",
  wm_lang_html_918362:"显示设置",
  wm_lang_65f627:"上传新文件",
  wm_lang_html_f48072:"安全提示：",
  wm_lang_bf3c5b:"韩语",
  wm_lang_html_ff1c7d:"查看信头",
  wm_lang_html_c4746d:"未选中任何邮件，单击一封在此处显示",
  wm_lang_153fa6:"选择",
  wm_lang_952f2d:"文件上传已达到最大上限数",
  wm_lang_f3a485:"新建文件夹",
  wm_lang_8f40db:"赋值",
  wm_lang_fcbb1f:"个文件，请删除当前文件后重新上传",
  wm_lang_html_2cc0ca:"修复读信页面样式、乱码等邮件解析问题；",
  wm_lang_3d14d1:"省",
  wm_lang_670d63:"确认新密码",
  wm_lang_html_2cb96f:"客户端设置",
  wm_lang_64a156:"您没有选择任何文件！",
  wm_lang_6b0bc6:"操作者",
  wm_lang_5f10ee:"经典木纹",
  wm_lang_554626:"第三步，赋值",
  wm_lang_html_c8a933:"立即修改",
  wm_lang_543586:"请输入正确的电话号码",
  wm_lang_df4b35:"当前已有规则",
  wm_lang_html_919466:"包含部门：",
  wm_lang_html_d88651:"剩余空间",
  wm_lang_21cf5e:"邮箱最大数量为",
  wm_lang_html_f75896:"所在组：",
  wm_lang_html_a72631:"必须包含大写字母、小写字母、数字、符号任意",
  wm_lang_0eeee5:"设置过滤规则，对邮件进行分类处理。",
  wm_lang_211cfb:"服务器不能为空",
  wm_lang_html_8ad629:"已读",
  wm_lang_05e8d4:"发送阅读回执",
  wm_lang_b90ee1:"普通上传组件",
  wm_lang_html_854db2:"全部置为已读",
  wm_lang_6105e1:"反垃圾处理",
  wm_lang_html_740499:"邮件从大到小",
  wm_lang_html_86ed3d:"移动到",
  wm_lang_c45357:"系统提示",
  wm_lang_html_44a2c7:"个联系人",
  wm_lang_html_288f0c:"清空",
  wm_lang_f070aa:"您好",
  wm_lang_716c3d:"街道",
  wm_lang_7deb96:"发信后收件人",
  wm_lang_24e8a8:"系统将自动清理“垃圾箱”中超过",
  wm_lang_4a0838:"新建签名",
  wm_lang_ac9f45:"回复成功",
  wm_lang_e0b014:"分类过滤规则最多可添加",
  wm_lang_0c9eaa:"的值为：",
  wm_lang_html_67596c:"没有任何邮件",
  wm_lang_html_ec0bce:"相关",
  wm_lang_html_cda4d5:"从联系人中选择",
  wm_lang_html_e13556:"包含",
  wm_lang_f5854e:"已取消星标",
  wm_lang_0c498b:"请联系管理员",
  wm_lang_cecc29:"写信",
  wm_lang_html_93d159:"已发送",
  wm_lang_05dfc3:"回执成功",
  wm_lang_aa2fb1:"请选择日期",
  wm_lang_0b2f8e:"中文简体",
  wm_lang_f9fb6a:"English",
  wm_lang_ff29b9:"邮件发送成功",
  wm_lang_html_053355:"后紧急成立统筹小组进行",
  wm_lang_b1415d:"请先选择要删除的地址！",
  wm_lang_html_78ad95:"附加意见：",
  wm_lang_d3950d:"粉色回忆",
  wm_lang_8beefb:"审核结果",
  wm_lang_0ad062:"第四步，丢包，等待",
  wm_lang_html_196bf0:"您尚未添加联系人",
  wm_lang_e0b004:"黑体",
  wm_lang_f10ed4:"新建规则",
  wm_lang_7c2f8e:"传真号码",
  wm_lang_348913:"皮肤",
  wm_lang_html_3950e5:"时间从旧到新",
  wm_lang_html_95bde0:"增加定时自动回复功能，支持按照时间周期设置自动回复；",
  wm_lang_8e22f1:"左侧导航",
  wm_lang_fd4cfa:"审计类型：",
  wm_lang_ca5f4c:"低级（除黑名单外的邮件，都不会判为垃圾邮件）",
  wm_lang_html_f5de9e:"附件名",
  wm_lang_html_aab57a:"反选",
  wm_lang_82da89:"审核人",
  wm_lang_html_d87502:"个字符以上主持人邮箱填写",
  wm_lang_572fc4:"系统文件夹不可删除",
  wm_lang_html_89da89:"：执行动作",
  wm_lang_a4c993:"您确定要删除组",
  wm_lang_b87f22:"审核失败（",
  wm_lang_230505:"撤回",
  wm_lang_333e4b:"目的文件夹和源文件夹相同",
  wm_lang_22c795:"授权码最多可添加",
  wm_lang_46042d:"超大附件",
  wm_lang_5c0086:"自定义名称不能超过",
  wm_lang_5f6025:"页面后生效。",
  wm_lang_5f4fd0:"顶栏容器",
  wm_lang_7354e6:"最近使用",
  wm_lang_html_5a3009:"提醒周期",
  wm_lang_html_f83e6b:"设置默认发信人姓名",
  wm_lang_a85cce:"规则状态",
  wm_lang_html_ca5b2d:"自动转发与回复",
  wm_lang_html_8347a9:"修改",
  wm_lang_2cf58f:"选项四",
  wm_lang_6732fd:"所有邮件",
  wm_lang_22b234:"在此文件夹下",
  wm_lang_html_ab20cc:"和",
  wm_lang_2685dc:"清空成功",
  wm_lang_2a8140:"删除所选的黑名单地址？",
  wm_lang_0efb20:"请至少选择一个",
  wm_lang_e61f2c:"同意",
  wm_lang_312df5:"您确定要删除此客户端授权码么？删除成功后，此授权码将无法在客户端上登录。",
  wm_lang_6aea59:"导入到组",
  wm_lang_html_83aa19:"自动转发地址上限",
  wm_lang_40ff1a:"位，不大于",
  wm_lang_8dd066:"绑定手机",
  wm_lang_html_ab9ed8:"没有搜索到匹配结果",
  wm_lang_html_021161:"性别：",
  wm_lang_65939c:"触发条件",
  wm_lang_fbd2b1:"共",
  wm_lang_cc1bac:"条",
  wm_lang_html_992cd2:"勇者前行",
  wm_lang_f3b7af:"密码用途",
  wm_lang_70a47f:"删除后，此附件的收件人将无法下载此附件。确定删除么？",
  wm_lang_442c6a:"组",
  wm_lang_html_894a10:"未读",
  wm_lang_defd7b:"发信人：",
  wm_lang_html_52b365:"步骤",
  wm_lang_html_d4095c:"常规设置",
  wm_lang_86988e:"邮箱重复",
  wm_lang_6367e7:"顺序",
  wm_lang_9ad8d3:"授权密码",
  wm_lang_html_392898:"，其中",
  wm_lang_html_44c32e:"组名称",
  wm_lang_html_026601:"或认证的用户名",
  wm_lang_html_d8b930:"邮件由",
  wm_lang_24969a:"抄送人",
  wm_lang_a41baf:"请填写签名名称",
  wm_lang_b2fbc1:"至少填写一项信息",
  wm_lang_html_c33c30:"商务办公",
  wm_lang_html_751ce6:"备注：",
  wm_lang_19a1ee:"草稿保存失败",
  wm_lang_6f67c4:"文件夹名不能包含后面任意字符：",
  wm_lang_html_92636e:"跳过",
  wm_lang_6b0fd2:"邮件列表",
  wm_lang_html_bf74e9:"发件人自定义姓名",
  wm_lang_html_930882:"个",
  wm_lang_787b56:"性别",
  wm_lang_7854b5:"启用",
  wm_lang_46ad5e:"超大附件空间不足",
  wm_lang_html_a675fc:"此密码由系统随机生成，请复制后妥善保管，如有遗忘，请删除重建。",
  wm_lang_html_f7b320:"号",
  wm_lang_html_88c952:"发件人",
  wm_lang_96900d:"选",
  wm_lang_5cd3b6:"高级（只有白名单、同域用户、通讯录联系人发来的邮件不视为垃圾邮件）",
  wm_lang_b7abee:"选项二",
  wm_lang_b6d16a:"导入成功",
  wm_lang_25c9ea:"审计人：",
  wm_lang_e75969:"收件箱",
  wm_lang_html_ca746b:"文字",
  wm_lang_c2b9f4:"根目录",
  wm_lang_8abc56:"操作栏",
  wm_lang_html_bb93ed:"备",
  wm_lang_696f5a:"创建日期",
  wm_lang_0c9e6a:"长度在",
  wm_lang_html_ed8f43:"同时将本组中所有联系人从个人通讯录中彻底删除。",
  wm_lang_html_93d79c:"的联系人",
  wm_lang_html_54480f:"企业邮箱作为防守单位之一，在接到三峡集团的行动邀请",
  wm_lang_html_8f5c40:"家庭邮编：",
  wm_lang_f30bfb:"多个转发地址之间请以英文逗号分隔",
  wm_lang_html_dec892:"：",
  wm_lang_1edff0:"回复",
  wm_lang_5f4112:"返回",
  wm_lang_html_614fc6:"示例：",
  wm_lang_html_390209:"不能包含用户名或域名",
  wm_lang_html_6b8677:"手动加入通讯录",
  wm_lang_330363:"成功",
  wm_lang_0d64f2:"中级（推荐，根据系统的反垃圾规则及黑白名单设置识别垃圾邮件）",
  wm_lang_html_4b9c32:"重置",
  wm_lang_5ac57c:"文本框",
  wm_lang_html_2d23c6:"审核记录：",
  wm_lang_html_12d795:"更早的更新记录",
  wm_lang_3683f3:"显示邮件图片",
  wm_lang_973732:"已转发",
  wm_lang_c2fe62:"筛选",
  wm_lang_c6cceb:"日程",
  wm_lang_78623e:"每天",
  wm_lang_dcc242:"支持最多创建",
  wm_lang_a5ff1b:"未转发",
  wm_lang_html_d4c366:"检测中",
  wm_lang_74225e:"下拉二",
  wm_lang_306a2a:"服务器长度不得超过",
  wm_lang_971f54:"微软雅黑",
  wm_lang_a6beb9:"开关",
  wm_lang_6a5f04:"请输入正确的邮箱地址",
  wm_lang_3caa33:"启用该账号",
  wm_lang_html_55c3f6:"取",
  wm_lang_f9d94b:"永久删除后邮件将无法恢复，您确认删除吗？",
  wm_lang_21cad5:"安全登录验证",
  wm_lang_html_22f94c:"域公告邮件共",
  wm_lang_af3c66:"邮箱最多添加",
  wm_lang_html_1a63ac:"示例",
  wm_lang_html_6e0780:"请用真实的账号登录",
  wm_lang_c00500:"抄送人：",
  wm_lang_18b2e0:"您被设置了“禁止自动转发到外域”，请与管理员联系！",
  wm_lang_1e9b8e:"请正确填写最小值",
  wm_lang_html_0c71d6:"设置默认字体",
  wm_lang_html_4a0838:"新建签名",
  wm_lang_237651:"邮件正在发送中",
  wm_lang_ac1e1c:"收件人：",
  wm_lang_d69797:"存在重复的转发地址",
  wm_lang_html_9ab2e7:"为非常用联系人，请注意核实对方身份",
  wm_lang_html_2f293a:"已星标",
  wm_lang_68018f:"幼圆",
  wm_lang_html_fcbc6a:"空格",
  wm_lang_html_cce9c9:"上次修改密码：",
  wm_lang_6e7b20:"只回复发件人",
  wm_lang_70281d:"请输入正确的电话",
  wm_lang_5df03b:"请输入文件夹名称",
  wm_lang_e10150:"文件夹名不能包含空格和特殊字符",
  wm_lang_8a45a9:"您确定要将此超大附件续期？",
  wm_lang_8ad629:"已读",
  wm_lang_0bb8f9:"垃圾邮件",
  wm_lang_cd043c:"请输入当前密码",
  wm_lang_a8b0c2:"全部",
  wm_lang_html_d3950d:"粉色回忆",
  wm_lang_74e5c0:"定时发送",
  wm_lang_95b351:"编辑",
  wm_lang_919ca6:"下拉一",
  wm_lang_55481b:"不提醒",
  wm_lang_3d99b6:"多个地址之间以英文逗号分隔",
  wm_lang_html_a7a342:"定",
  wm_lang_html_1c02de:"往来邮件",
  wm_lang_html_8d0cfb:"添加文件",
  wm_lang_f857f6:"密码用途不能包含空格和",
  wm_lang_html_66eeac:"全选",
  wm_lang_html_897d4f:"解决垃圾邮件的识别和误判问题；",
  wm_lang_html_6b05b5:"发信设置",
  wm_lang_e4a3b5:"请输入黑名单地址",
  wm_lang_f0d640:"两次输入密码不一致",
  wm_lang_96ce79:"，无法添加该文件",
  wm_lang_html_6219c6:"的邮件列表",
  wm_lang_d9e569:"添加账号成功",
  wm_lang_fddcd7:"导入失败",
  wm_lang_html_58378f:"正文",
  wm_lang_html_e93381:"企业邮箱助三峡",
  wm_lang_html_536d2c:"直接删除邮件",
  wm_lang_d27299:"仅对每个发件人发送一次自动回复",
  wm_lang_443f46:"多选",
  wm_lang_35a2b9:"您确定要开启",
  wm_lang_html_552823:"保存为默认签名",
  wm_lang_3fea7c:"状态",
  wm_lang_html_e5ff1a:"请选择要添加的文件：",
  wm_lang_c3ba16:"已归档",
  wm_lang_html_6b0fd2:"邮件列表",
  wm_lang_992cd2:"勇者前行",
  wm_lang_html_df99b1:"您的邮箱账号存在一定的安全风险，请按照以下提示进行优化。",
  wm_lang_html_a46aa1:"添加其他邮箱账号",
  wm_lang_html_4c785f:"添加附件",
  wm_lang_html_4a5c68:"上传至我的网盘",
  wm_lang_html_e0745b:"取消星标",
  wm_lang_0d8f65:"红色简约",
  wm_lang_19fcb9:"时间",
  wm_lang_html_442c6a:"组",
  wm_lang_html_5751bf:"座机：",
  wm_lang_2b9bad:"通讯组名称不能为空",
  wm_lang_27bf68:"您的邮箱密码过于简单，为了您的账号安全，请修改密码",
  wm_lang_fb5bf1:"收件人",
  wm_lang_9dcd1b:"您确定要将所选的联系人移出此组？",
  wm_lang_html_2a2080:"文件。",
  wm_lang_511fd1:"您当前正在使用”群发单显”功能，此功能对群发的邮件，采用分别发送，每个收件人只能看到自己的邮箱地址，是否继续？",
  wm_lang_html_600565:"不能包含三个连续或相同的字符",
  wm_lang_html_249aba:"天",
  wm_lang_html_40ff1a:"位，不大于",
  wm_lang_7edd32:"晚上好！",
  wm_lang_html_c3eb73:"文件夹管理",
  wm_lang_html_abb501:"金色时光",
  wm_lang_html_e75969:"收件箱",
  wm_lang_e6df5b:"添加说明",
  wm_lang_html_cb0e98:"勾选全部",
  wm_lang_12f1d7:"结束",
  wm_lang_4ff1e7:"日期",
  wm_lang_19fee2:"每五天",
  wm_lang_a30c4e:"新建组",
  wm_lang_3cec17:"密码长度不得超过",
  wm_lang_html_727725:"公司地址：",
  wm_lang_html_267e95:"新建联系人",
  wm_lang_9c49ab:"确定不填写主题吗",
  wm_lang_html_cc4637:"不能用过于简单的密码，如",
  wm_lang_2f2786:"操作内容",
  wm_lang_5abe91:"未星标",
  wm_lang_d26ecc:"邮箱名",
  wm_lang_html_bcbfe2:"黑名单",
  wm_lang_html_90585c:"设置代办",
  wm_lang_html_c2fe62:"筛选",
  wm_lang_650b9f:"至少选择一个对应字段",
  wm_lang_da760a:"其他邮箱账户（",
  wm_lang_3806fe:"转发地址",
  wm_lang_html_918be6:"种的组合",
  wm_lang_f361ce:"已设为未读",
  wm_lang_1e328f:"请选择上传文件",
  wm_lang_html_570e7f:"给我发送提醒邮件",
  wm_lang_ae4b6b:"个签名",
  wm_lang_59592b:"签名名称",
  wm_lang_html_0182f1:"时尚酷黑",
  wm_lang_10a48a:"请添加收件人后再发送",
  wm_lang_358fd1:"移动成功",
  wm_lang_397654:"上传头像图片只能是",
  wm_lang_4351f4:"早上好！",
  wm_lang_html_458e42:"已勾选本页",
  wm_lang_2f293a:"已星标",
  wm_lang_249aba:"天",
  wm_lang_html_e37075:"高级设置",
  wm_lang_html_be2525:"签名",
  wm_lang_41ec00:"框",
  wm_lang_html_88866c:"已部分撤回",
  wm_lang_html_2d76b9:"职位：",
  wm_lang_b4f3cb:"正在收取",
  wm_lang_f2e77e:"每四天",
  wm_lang_f0b9f4:"第五步，分片上传",
  wm_lang_html_f515f8:"重新检测",
  wm_lang_html_808773:"发件人降序",
  wm_lang_a24ab0:"请再次输入密码",
  wm_lang_html_3d2a2f:"上传插件，支持极速秒传、断点续传",
  wm_lang_html_c00500:"抄送人：",
  wm_lang_ace6d1:"勾选了自动回复，则自动回复内容不能为空",
  wm_lang_674b1e:"收信账号，可以收取其他邮箱的邮件。",
  wm_lang_2bebdd:"选择日期",
  wm_lang_html_ecf9b6:"自动转发设置日志",
  wm_lang_cc2644:"请标记此授权码的用途，以免遗忘",
  wm_lang_35c8ad:"自动转发",
  wm_lang_html_b4cc1c:"特殊字符",
  wm_lang_html_b411f8:"增加全文搜索功能，支持按照邮件正文或附件名搜索邮件；",
  wm_lang_88c952:"发件人",
  wm_lang_0ec9ea:"更多",
  wm_lang_e4b8bb:"总封数",
  wm_lang_html_dfe48d:"个，",
  wm_lang_29d8d8:"个人备注",
  wm_lang_316206:"设置待办",
  wm_lang_html_b960ee:"上传至超大附件",
  wm_lang_894a10:"未读",
  wm_lang_html_0bb8f9:"垃圾邮件",
  wm_lang_01efad:"新增客户端授权码",
  wm_lang_html_2161fa:"不能与原密码相同",
  wm_lang_2d711b:"内容",
  wm_lang_html_5f4112:"返回",
  wm_lang_html_e366cc:"设置",
  wm_lang_7173f8:"拒绝",
  wm_lang_html_bf498c:"初始默认提示文字",
  wm_lang_295bb7:"语言",
  wm_lang_html_0345b9:"发件人升序",
  wm_lang_a8424d:"请重新输入",
  wm_lang_html_e7d4e2:"生成授权码",
  wm_lang_361e3d:"左侧设置导航",
  wm_lang_958962:"编辑文件夹",
  wm_lang_28ee2b:"无权限，请联系管理员",
  wm_lang_html_79d3ab:"复制",
  wm_lang_03dcfd:"每三天",
  custom_lang_0001:"请输入密码",
  custom_lang_0002:"两次密码输入不一致",
  custom_lang_0003:"您好：",
  custom_lang_0004:"这是一封加密邮件，需要解密后才能查看邮件内容，您可以通过其它方式向发件人询问密码",
  custom_lang_0005:"以下地址不存在或格式错误,请检查:",
  custom_lang_0006:"您要删除以下文件夹吗？",
  custom_lang_0007:"操作已成功，您的裁决判定是",
  custom_lang_0008:"显示",
  custom_lang_0009:"请勿重复添加",
  custom_lang_0010:"邮箱",
  custom_lang_0011:"已存在!",
  custom_lang_0012:"只能上传csv格式文件，且不超过",
  custom_lang_0013:"将",
  custom_lang_0014:"中的联系人以CSV格式导出。",
  custom_lang_0015:"通讯组名称长度不能超过",
  custom_lang_0016:"个字符",
  custom_lang_0017:"您尚未收到任何域公告邮件。",
  custom_lang_0018:"更多操作",
  custom_lang_0019:"另存为eml文件",
  custom_lang_0020:"手动添加常用登录地址至",
  custom_lang_0021:"信任登录地点",
  custom_lang_0022:"，邮箱账号异地登录时系统自动发送异地登录提醒，点此查看",
  custom_lang_0023:"异地登录日志",
  custom_lang_0024:"操作失败",
  custom_lang_0025:"请选择信任地点",
  custom_lang_0026:"请选择信任地点，至少选择“省”",
  custom_lang_0027:"删除所选的信任地点？",
  custom_lang_0028:"最多添加20个信任地点",
  custom_lang_0029:"直接把文件拖放至此区域内，即可作为附件添加",
  custom_lang_0030:"条匹配，请输入更多信息以缩小范围",
  custom_lang_0031:"密码长度不能大于20位",
  custom_lang_0032:"更多结果请查看邮件撤回通知",
  custom_lang_0033:"登录",
  custom_lang_0034:"密码错误",
  custom_lang_0035:"定时发送邮件",
  custom_lang_0036:"请选择定时发信时间",
  custom_lang_0037:"设置的时间已过期",
  custom_lang_0038:"已选择",
  custom_lang_0039:"未选中任何联系人，单击一条联系人信息在此显示",
  custom_lang_0040:"今天",
  custom_lang_0041:"明天",
  custom_lang_0042:"昨天",
  custom_lang_0043:"附件大小超限，最大",
  custom_lang_0044:"收件人数超限，最多",
  custom_lang_0045:"您所选择的文件已经超过了普通附件",
  custom_lang_0046:"的大小上限，请上传到超大附件。",
  custom_lang_0047:"有效期",
  custom_lang_0048:"密码不能包含空格",
  custom_lang_0049:"请输入密码：",
  custom_lang_0050:"是否将",
  custom_lang_0051:"加入黑名单？",
  custom_lang_0052:"请选择要删除的地点",
  custom_lang_0053:"不使用",
  custom_lang_0054:"默认排序",
  custom_lang_0055:"姓名升序",
  custom_lang_0056:"姓名降序",
  custom_lang_0057:"邮件地址升序",
  custom_lang_0058:"邮件地址降序",
  custom_lang_0059:"请上传小于1M的图片",
  custom_lang_0060:"删除组",
  custom_lang_0061:"外部联系人",
  custom_lang_0062:"收件箱",
  custom_lang_0063:"发件箱",
  custom_lang_0064:"已删除",
  custom_lang_0065:"草稿箱",
  custom_lang_0066:"垃圾箱",
  custom_lang_0067:"已归档",
  custom_lang_0068:"已备份",
  custom_lang_0069:"星标邮件",
  custom_lang_0070:"待办邮件",
  custom_lang_0071:"内部网络",
  custom_lang_0072:"您好!",
  custom_lang_0073:"您要清空以下文件夹吗？",
  custom_lang_0074:"已移动到",
  custom_lang_0075:"成功撤回",
  custom_lang_0076:"投递中或分类过滤删除，无法撤回",
  custom_lang_0077:"撤回失败，邮件可能已被删除",
  custom_lang_0078:"对方非本邮件系统邮箱或邮箱地址不存在，无法撤回",
  custom_lang_0079:"步骤2：选择所要导入的分组及文件所对应的字段名称。",
  custom_lang_0080:"是否删除签名",
  custom_lang_0081:"是否删除 ",
  custom_lang_0082:" 账号",
  custom_lang_0083:"自动转发地址数量超过最大限制",
  custom_lang_0084:"数量不能超过",
  custom_lang_0085:"等自动回复标识时，将不会再自动给对方回复。",
  custom_lang_0086:"时间段不能为空",
  custom_lang_0087:"开启自动转发",
  custom_lang_0088:"关闭自动转发",
  custom_lang_0089:"修改自动转发",
  custom_lang_0090:"未知",
  custom_lang_0091:"新建规则",
  custom_lang_0092:"修改规则",
  custom_lang_0093:"删除规则",
  custom_lang_0094:"上移规则",
  custom_lang_0095:"下移规则",
  custom_lang_0096:"4.只能撤回",
  custom_lang_0097:"小时",
  custom_lang_0098:"日",
  custom_lang_0099:"内发送的邮件",
  custom_lang_0100:"登录二次验证",
  custom_lang_0101:"根据此账号的安全设置，本次登录需要短信验证。（如遇到特殊情况无法验证，您可联系公司管理员解绑手机）",
  custom_lang_0102:"已绑定手机",
  custom_lang_0103:"获取验证码",
  custom_lang_0104:"短信验证码",
  custom_lang_0105:"请输入验证码",
  custom_lang_0106:"同一浏览器登录免二次验证",
  custom_lang_0107:"60秒再次获取",
  custom_lang_0108:"验证码短信已发送，请注意查收。",
  custom_lang_0109:"验证码输入有误",
  custom_lang_0110:"验证码无效或已过期",
  custom_lang_0111:"安全提醒",
  custom_lang_0112:"绑定手机",
  custom_lang_0113:"提醒方式",
  custom_lang_0114:"邮件提醒",
  custom_lang_0115:"短信提醒",
  custom_lang_0116:"安全登录",
  custom_lang_0117:"登录二次验证",
  custom_lang_0118:"开启二次登录验证后，用户登录网页邮箱时，除账号密码验证外，还需要二次验证",
  custom_lang_0119:"验证方式",
  custom_lang_0120:"每次登录验证",
  custom_lang_0121:"异地登录验证",
  custom_lang_0122:"手机号码",
  custom_lang_0123:"短信验证码",
  custom_lang_0124:"请输入手机号码",
  custom_lang_0125:"请输入验证码",
  custom_lang_0126:"手机号码格式有误",
  custom_lang_0127:"验证码输入有误",
  custom_lang_0128:"获取验证码",
  custom_lang_0129:"秒再次获取",
  custom_lang_0130:"验证码短信已发送，请注意查收。",
  custom_lang_0131:"若无法通过原手机号码验证，请联系公司管理员进行解绑。",
  custom_lang_0132:"您的邮箱账号已绑定手机",
  custom_lang_0133:"解绑手机",
  custom_lang_0134:"绑定成功",
  custom_lang_0135:"解绑成功",
  custom_lang_0136:"解除绑定",
};



// WEBPACK FOOTER //
// ./src/vueI18n/cn.js